<template>
  <div class="row">
    <div class="col-md-8 col-md-offset-2">
      <div class="panel panel-default">
        <div class="panel-heading" v-if="post.title">{{ post.title }}</div>
        <div class="panel-body">
          <form method="POST" @submit.prevent="submitPost">
            <div class="form-group">
              <label for="title" class="control-label">Titre</label>
              <input type="text" name="title" id="title" class="form-control" v-model="post.title"/>
            </div>
            <div class="form-group">
              <label for="slug" class="control-label">Slug</label>
              <input type="text" name="slug" id="slug" placeholder="(généré à partir du titre)"
                     class="form-control" v-model="postSlug"/>
            </div>
            <div class="form-group">
              <img v-if="post.illustration" :src="post.illustration" :alt="post.title"/>
            </div>
            <div class="form-group">
              <label for="illustration" class="control-label">Illustration</label>
              <input type="file" name="illustration" id="illustration" class="form-control" accept="image/*" @change="onFileChange"/>
            </div>
            <div class="form-group">
              <label for="content" class="control-label">Contenu</label>
              <textarea name="content" id="content" class="form-control"></textarea>
            </div>
            <div class="form-group">
              <loader-box v-if="categoriesLoading"/>
              <label for="category_id" class="control-label">Catégorie</label>
              <select name="category_id" @change="loadSubCategories(post.category_id)" v-model="post.category_id" id="category_id" class="form-control">
                <option :value="category.id" v-for="category in categories" :key="category.id">{{ category.name }}</option>
              </select>
            </div>
            <transition name="fade">
              <div class="form-group" v-if="post.category_id !== 0">
                <loader-box v-if="subCategoriesLoading"/>
                <label for="sub_category_id" class="control-label">Sous catégorie</label>
                <select name="sub_category_id" v-model="post.sub_category_id" id="sub_category_id" class="form-control">
                  <option :value="sub_category.id" v-for="sub_category in sub_categories" :key="sub_category.id">{{ sub_category.name }}</option>
                </select>
              </div>
            </transition>
            <button class="btn btn-block btn-primary">{{ submitLabel }} <i :class="submitIconClass"></i></button>
            <slot/>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import LoaderBox from '../Loader/LoaderBox'
  import Swal from 'sweetalert2'
  export default {
    components: {LoaderBox},
    props: {
      categoryId: {type: Number, default: 0},
      subCategoryId: {type: Number, default: 0},
      categoryUrl: {type: String},
      subCategoryUrl: {type: String},
      title: {type: String, default: ''},
      isEditing: {type: Boolean, default: false},
      postProp: {
        type: Object, default () {
          return {}
        }
      },
    },
    data () {
      return {
        categoriesLoading: false,
        subCategoriesLoading: false,
        post: {
          title: '',
          slug: '',
          content: '',
          category_id: 0,
          sub_category_id: 0,
          illustration: ''
        },
        categories: [],
        sub_categories: []
      }
    },
    computed: {
      postSlug: {
        get () {
          return !this.post.slug ? this.post.title.split(' ').join('-') : this.post.slug
        },
        set (value) {
          this.post.slug = value
        }
      },
      submitIconClass () {
        return {
          'fa fa-save': this.isEditing,
          'fa fa-plus': !this.isEditing
        }
      },
      submitLabel () {
        return this.isEditing ? 'Enregistrer' : 'Ajouter'
      }
    },
    methods: {
      onFileChange (e) {
        let files = e.target.files || e.dataTransfer.files;
        if (!files.length)
          return
        let reader = new window.FileReader()
        reader.addEventListener('load', (e) => {
          this.post.illustration = e.target.result
        })
        reader.readAsDataURL(files[0])
      },
      loadCategories () {
        return new Promise((resolve, reject) => {
          this.categoriesLoading = true
          appAxios.get(this.categoryUrl)
            .then(apiResponse => {
              this.categories = apiResponse.getData()
              resolve(this.categories)
            })
            .catch(apiResponse => {
              console.error(apiResponse)
              Swal({
                text: 'Erreur lors du chargement des catégories',
                type: 'error'
              })
              reject(apiResponse)
            })
            .then(_ => this.categoriesLoading = false)
        })
      },
      loadSubCategories (category_id) {
        return new Promise((resolve, reject) => {
          this.post.sub_category_id = 0
          this.subCategoriesLoading = true
          appAxios.get(this.subCategoryUrl.replace(':category', category_id))
            .then(apiResponse => {
              this.sub_categories = apiResponse.getData()
              if (this.sub_categories.length) {
                this.post.sub_category_id = this.sub_categories[0].id
              }
              resolve(this.sub_categories)
            })
            .catch(error => {
              console.error(error)
              Swal({
                text: 'Erreur lors du chargement des sous-catégories',
                type: 'error'
              })
              reject(error)
            })
            .then(_ => this.subCategoriesLoading = false)
        })
      },
      submitPost () {
        this.post.content = $('#content').trumbowyg('html')
        this.post.slug = this.postSlug
        this.$emit('post-form-submitted', this.post)
      }
    },
    mounted () {
      this.post = Object.assign({}, this.post, this.postProp)
      // wait for DOM to be loaded because asset js and css are loaded outside of this component
      $('#content').trumbowyg({
        lang: 'fr',
        autogrow: true,
        imageWidthModalEdit: true,
        // btns: [
        //   ['upload']
        // ],
        plugins: {
          upload: {
            serverPath: '/attachable',
            fileFieldName: 'attachment'
            // Some upload plugin options, see details below
          }
        }
      })
      $('#content').trumbowyg('html', this.post.content)

      this.loadCategories()
        .then(categories => {
          this.post.category_id = this.categoryId
          if (this.subCategoryId) {
            this.loadSubCategories(this.categoryId)
              .then(_ => this.post.sub_category_id = this.subCategoryId)
          } else if (categories.length) {
            this.loadSubCategories(categories[0].id)
          }
        })
    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/component/Post/PostForm.vue